/**
 * Scene axes (MineDynamics):
 *   x = East,  y = RL (up),  z = South  (so North = -z)
 *
 * Azimuth: 0 = North, 90 = East, 180 = South, 270 = West (clockwise).
 * Dip:     0 = horizontal, positive = up, negative = down (±90 vertical).
 */
function sceneDeltas(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const dz = p2.z - p1.z;
  const dEast = dx;
  const dNorth = -dz;
  const dUp = dy;
  const horiz = Math.hypot(dEast, dNorth);
  const dist = Math.hypot(dEast, dNorth, dUp);

  let azimuth = 0;
  if (horiz > 1e-8) {
    azimuth = (Math.atan2(dEast, dNorth) * 180) / Math.PI;
    if (azimuth < 0) azimuth += 360;
  }

  const dip = (Math.atan2(dUp, horiz) * 180) / Math.PI;

  return { dx, dy, dz, dEast, dNorth, dUp, horiz, dist, azimuth, dip };
}

export function calculateDistancesAndAngles(points) {
  if (points.length < 3) return null;

  const measurements = [];

  for (let i = 0; i < points.length - 1; i++) {
    const p1 = points[i];
    const p2 = points[i + 1];
    const { dx, dy, dz, dist, azimuth, dip } = sceneDeltas(p1, p2);

    measurements.push({
      p1,
      p2,
      dx,
      dy,
      dz,
      dist,
      d: dip,
      a: azimuth,
      arc: 0,
    });
  }

  return measurements;
}

export function distanceMeasure(points) {
  if (points.length !== 2) return null;

  const p1 = points[0];
  const p2 = points[1];
  const { dx, dy, dz, dist, azimuth, dip } = sceneDeltas(p1, p2);

  return {
    p1,
    p2,
    dx: Number(dx).toFixed(1),
    dy: Number(dy).toFixed(1),
    dz: Number(dz).toFixed(1),
    dist: Number(dist).toFixed(1),
    d: Number(dip).toFixed(1),
    a: Number(azimuth).toFixed(1),
    arc: 0,
  };
}

/** Recompute azimuth/dip/distance from stored endpoints (scene x=East, y=RL, z=South). */
export function anglesFromEndpoints(p1, p2) {
  if (!p1 || !p2) return null;
  const a = p1.x != null ? p1 : { x: p1[0], y: p1[1], z: p1[2] };
  const b = p2.x != null ? p2 : { x: p2[0], y: p2[1], z: p2[2] };
  if (![a.x, a.y, a.z, b.x, b.y, b.z].every(Number.isFinite)) return null;
  const { dy, dist, azimuth, dip } = sceneDeltas(a, b);
  return {
    a: Number(azimuth).toFixed(1),
    d: Number(dip).toFixed(1),
    dist: Number(dist).toFixed(1),
    dy: Number(dy).toFixed(1),
  };
}
